import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { editorOptions } from 'src/app/constants/editor-options';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Component({
    selector: 'category-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CategoryEdit implements OnInit {
  public form: FormGroup;

  public editorOptions = editorOptions;
  public existingCategory: boolean;
  public existingCategories;

  constructor(
    protected dialogRef: MatDialogRef<CategoryEdit>,
    private commonFunctionService: CommonFunctionService,
    @Inject(MAT_DIALOG_DATA) public config
  ) {}
  get files() {
    return this.form.get('files') as FormArray;
  }

  ngOnInit() {
    const { Category, existingCategories } = this.config;

    this.existingCategory = !!Category;
    this.existingCategories = existingCategories;
    const formBuilder = new FormBuilder();
    this.form = formBuilder.group({
      title: [null, [Validators.required]],
      description: [null, [Validators.required]],
      parent_id: [null, null],
      kind: [null, [Validators.required]],
      font_icon: [null, null],
      files: formBuilder.array([], [Validators.required]),
      web_only: [false, null],
      display_in_menu: [true, null]
    });

    if (this.existingCategory) {
      Object.keys(Category).forEach((name) => {
        if (this.form.controls[name]) {
          this.form.controls[name].patchValue(Category[name]);
        } else if (
          name === 'banner_image' &&
          Category['banner_image'] !== null
        ) {
          const src =
            this.commonFunctionService.findApiUrl('admin') +
            '/admin/category/' +
            Category.id +
            '/image?' +
            Date.now();

          this.addFiles(src, Category['banner_image_name'], '.jpg');
        }
      });
    }
  }

  public fileUpload(event: any) {
    const fileList: FileList = event.target.files;

    this.fileChange(fileList);
  }

  public fileChange(fileList: FileList) {
    if (fileList.length > 0) {
      for (let i = 0; i < fileList.length; i++) {
        const reader = new FileReader();

        reader.onload = (
          (file: any) => (event: any) =>
            this.addFiles(event.target.result, file.name, file.type)
        )(fileList[i]);

        reader.readAsDataURL(fileList[i]);
      }
    }
  }

  public removeFile(file: AbstractControl) {
    const index = this.files.controls.indexOf(file);

    this.files.removeAt(index);
  }

  private addFiles(src: string, name: string, type: string) {
    this.files.push(
      new FormBuilder().control({
        src,
        name,
        type,
      })
    );
  }

  onSubmit() {
    this.form.disable();
    const _Category = {
      ...this.getRawListing(),
    };
    if (_Category.files[0].src[0] == 'h') {
      delete _Category.files;
    }
    this.config.CategoryDataSource.save(_Category).then(
      (categoryId) => {
        return this.dialogRef.close(
          Object.assign({ id: categoryId }, _Category)
        );
      },
      () => this.form.enable()
    );
  }

  private getRawListing() {
    const form = this.form.getRawValue();
    const description = form.description.replace(/<p><br><\/p>/g, '');
    if (this.existingCategory) {
      form.id = this.config.Category.id;
    }
    return {
      ...form,
      description,
    };
  }
}
